export default {
  programs: [],
  loading: false,
  program: null,
}
